import React, {useMemo} from "react";
import {
  Text,
  StyleSheet, View,
} from "@react-pdf/renderer";

import {
  calculatePdfFontSize,
  calculatePdfHeight,
} from "../../../Utils";
import {FormPrintOptionsType} from "../../../Types";
import {PdfLabelSimpleType} from "../Types/Pdf";
import {getAutoTextSize, getPdfSimpleDiscountDetailSize} from "../Config";

export const PdfSimple = ({printOptions, label, colorRed}: { printOptions: FormPrintOptionsType, label: PdfLabelSimpleType, colorRed: string }) => {
  const styles = StyleSheet.create({
    simpleContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    gammeDiscount: {
      fontFamily: "Sunborn",
      color: colorRed,
      textAlign: "center",
    },
    gammeDiscountPrecision: {
      fontFamily: "LeagueSpartan",
      fontWeight: "bold",
      color: "black",
      textAlign: "center",
      paddingLeft: calculatePdfHeight(15, printOptions.size),
      paddingRight: calculatePdfHeight(15, printOptions.size),
    }
  });

  const themeSimpleContainer = useMemo(() => ({
    portrait: {
      height: calculatePdfHeight(460, printOptions.size),
    },
    landscape: {
      height: calculatePdfHeight(260, printOptions.size),
    }
  }), [printOptions.size]);

  const themeGammeDiscount = useMemo(() => ({
    portrait: {
      fontSize: calculatePdfFontSize(getAutoTextSize(label.discount, 220, 5), printOptions.size),
      marginBottom: calculatePdfHeight(-60, printOptions.size),
    },
    landscape: {
      fontSize: calculatePdfFontSize(getAutoTextSize(label.discount, 180, 5), printOptions.size),
      marginTop: calculatePdfHeight(-45, printOptions.size),
      marginBottom: calculatePdfHeight(-45, printOptions.size),
    }
  }), [printOptions.size, label.discount]);

  const themeGammeDiscountPrecision = useMemo(() => ({
    portrait: {
      fontSize: calculatePdfFontSize(getPdfSimpleDiscountDetailSize(label.mechanical, 'portrait'), printOptions.size)
    },
    landscape: {
      fontSize: calculatePdfFontSize(getPdfSimpleDiscountDetailSize(label.mechanical, 'landscape'), printOptions.size)
    }
  }), [printOptions.size, label.mechanical]);

  return (
    <View style={{...styles.simpleContainer, ...themeSimpleContainer[printOptions.orientation]}}>
      <Text style={{...styles.gammeDiscount, ...themeGammeDiscount[printOptions.orientation]}}>
        {label.discount}
      </Text>
      <Text style={{...styles.gammeDiscountPrecision, ...themeGammeDiscountPrecision[printOptions.orientation]}}>
        {label.discountDetail}
      </Text>
    </View>
  );
};

export default PdfSimple;
